import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { setCookie } from '@modules/auth/utils'
import { ShortlistSort } from '@modules/shortlist/types'

interface PersistStore {
  previousUrlPathname: string
  previousUrlSearch: string
  chatModalOpen: boolean
  chatIdToOpen: number | null
  shortlistSortMap: Record<string, ShortlistSort | null>

  persistUrlData: () => void
  clearUrlData: () => void

  setChatModalOpen: (isOpen: boolean) => void
  setChatIdToOpen: (id: string | null) => void

  setShortlistSort: (id: number, sort: ShortlistSort | null) => void
}

const P1_LOGIN_REDIRECT_COOKIE_FIELD_NAME = 'lastVisitedUrl'

export const usePersistStore = create<PersistStore>()(
  persist(
    set => ({
      shortlistSortMap: {},
      previousUrlPathname: '',
      previousUrlSearch: '',
      chatModalOpen: false,
      chatIdToOpen: null,

      persistUrlData: () => {
        const { pathname, search } = window.location

        setCookie(P1_LOGIN_REDIRECT_COOKIE_FIELD_NAME, `${pathname}${search}`, { path: '/', secure: true })

        set({
          previousUrlPathname: pathname,
          previousUrlSearch: search,
        })
      },
      clearUrlData: () => {
        setCookie(P1_LOGIN_REDIRECT_COOKIE_FIELD_NAME, '', { path: '/', secure: true })

        set({
          previousUrlPathname: '',
          previousUrlSearch: '',
        })
      },

      setChatModalOpen: (isOpen: boolean) => {
        set({ chatModalOpen: isOpen })
      },

      setChatIdToOpen: (id: string | null) => {
        const chatId = Number(id)
        set({ chatIdToOpen: Number.isNaN(chatId) ? null : chatId })
      },

      setShortlistSort: (id, shortlistSort) => {
        set(state => ({ ...state, shortlistSortMap: { ...state.shortlistSortMap, [id]: shortlistSort } }))
      },
    }),
    {
      name: 'c8093b3c0f8d',
    },
  ),
)
